import { useState } from 'react';
import { toast } from 'react-toastify';
import { useDropzone } from 'react-dropzone';
import { MainDashboardLayoutComponent } from 'components/main-layout/main.component';
import { StandartImageComponent } from 'components/image/standart-image.component';
import { useDownloadTemplateImportProduct, useImportProduct } from 'api/product/product-create/product-create.mutation';
import { ButtonSubmit } from 'components/button/button-submit.component';
import { useNavigate } from 'react-router-dom';
import { getReactDropZoneErrorMessage } from 'ui-utils/string.utils';

const BREAD_CUMB_ITEMS = [
  {
    title: 'Product',
    path: '/product/list',
  },
  {
    title: 'Import Product',
    path: '/product/list',
  },
];

export const ImportProductComponent = () => {
  const {
    mutate: downloadTemplateImport,
    isLoading: isDownloading,
    isSuccess: isTemplateDownloaded,
  } = useDownloadTemplateImportProduct();
  const navigate = useNavigate();

  const { mutate: importProduct, isLoading: isUploading } = useImportProduct();

  const [fileBuffer, setFileBuffer] = useState(null);
  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: {
      // excel file only
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx', '.xls'],
    },
    onDropAccepted: (files) => {
      if (!fileBuffer) setFileBuffer(files[0]);
    },
    onDropRejected: (files) => {
      toast.error(getReactDropZoneErrorMessage(files[0].errors[0]));
    },
  });

  const handleOnDownloadTemplateImport = () => {
    downloadTemplateImport(
      {},
      {
        onSuccess: (data) => {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'template-import-product.xlsx');
          document.body.appendChild(link);
          link.click();
        },
      }
    );
  };

  const handleOnImportProduct = () => {
    const formData = new FormData();
    formData.append('file', fileBuffer);
    importProduct(formData, {
      onSuccess: (data) => {
        setFileBuffer(null);
        toast.success('Import product success!');
        navigate('/product/list');
      },
    });
  };

  return (
    <MainDashboardLayoutComponent breadCumbs={BREAD_CUMB_ITEMS}>
      {!isTemplateDownloaded && (
        <div class='flex justify-between items-center border-t border-solid border-t-gray-1 p-3'>
          <div class='w-[80%]'>
            <div class='flex items-center'>
              <div class='max-w-[350px] flex items-center'>
                <div class='w-auto'>
                  <div class='text-sm text-gray font-semibold overflow-hidden text-ellipsis whitespace-nowrap'>
                    Please download the template first!
                  </div>
                </div>
                <div class='w-6 ml-3'>
                  <div class='w-[220px]'>
                    <ButtonSubmit
                      onClick={handleOnDownloadTemplateImport}
                      loading={isDownloading}
                      className='w-full flex items-center justify-center bg-green hover:bg-dark-green transition duration-75 ease-in-out rounded-sm text-white py-2 font-semibold text-sm px-7'
                      type='button'
                    >
                      <span class='icon-ico-download mr-2'></span>
                      Download Now
                    </ButtonSubmit>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div class='bg-gray-3'>
        <div class='drag-upload' {...getRootProps({ className: 'dropzone' })}>
          <input type='file' id='upload-drag' class='hidden' {...getInputProps()} />
          <div htmlFor='upload-drag' class='flex justify-center items-center w-full h-64 cursor-pointer'>
            <div class='w-auto'>
              <StandartImageComponent src='/img/import.png' class='max-w-full' />
              <p class='text-center text-green block text-base mt-4 font-semibold'>Drag File Here</p>
              <p class='text-center text-gray block text-sm '>EXCEL File Format</p>
            </div>
          </div>
        </div>

        <div class='flex justify-between items-center border-t border-solid border-t-gray-1 p-3'>
          <div class='w-[80%]'>
            <div class='flex items-center'>
              <div class='mr-5'>
                <input type='file' id='upload' class='hidden' disabled={isUploading} />
                <div {...getRootProps({ className: 'dropzone' })}>
                  <div
                    htmlFor='upload'
                    class='disabled:opacity-40 outline-none flex items-center border border-gray-1 font-semibold rounded-sm hover:bg-light-green transition hover:border-green duration-150 ease-in-out border-solid py-2 px-3 cursor-pointer'
                  >
                    <span class='icon-ico-upload mr-3'></span>
                    <span class='text-sm'>Select File</span>
                  </div>
                </div>
              </div>

              {fileBuffer && (
                <>
                  <div class='mr-5'>
                    <div class='text-base font-semibold text-green'>File Imported</div>
                  </div>

                  <div class='max-w-[350px] flex items-center'>
                    <div class='w-auto'>
                      <div class='text-sm text-gray font-semibold overflow-hidden text-ellipsis whitespace-nowrap'>
                        {fileBuffer.name}
                      </div>
                    </div>
                    <div class='w-6 ml-3'>
                      <button class='text-red-1 outline-none text-lg' onClick={() => setFileBuffer(null)}>
                        <span class='icon-ico-close-circle'></span>
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {fileBuffer && (
            <div class='w-[220px]'>
              <ButtonSubmit
                loading={isUploading}
                onClick={handleOnImportProduct}
                className='w-full flex items-center justify-center bg-green hover:bg-dark-green transition duration-75 ease-in-out rounded-sm text-white py-2 font-semibold text-sm px-7'
                type='button'
              >
                <StandartImageComponent src='/img/icon/arrow-down-left.svg' class='mr-3 max-w-full' /> Import Now
              </ButtonSubmit>
            </div>
          )}
        </div>
      </div>
    </MainDashboardLayoutComponent>
  );
};
